<nav class="navbar navbar-expand-lg fixed-top">
    <a class="navbar-brand">
        <img class="logo" src="./assets/images/logo_new.png" />
    </a>
    <!-- <span class="logo-span">{{ sitename }}</span> -->

    <div class="collapse navbar-collapse">
        <ul class="navbar-nav ms-auto">

            <li class="nav-item" ngbDropdown>
                <a class="nav-link" ngbDropdownToggle>
                    <img *ngIf="imageSrc" [src]="imageSrc" alt="User Image" class="avatar"/>
                    <span class="user-name">{{ user?.name }}</span>
                </a>
                <ul ngbDropdownMenu class="lgn-btn">
                    <li>
                        <!-- File input for image upload -->
                        <input type="file" id="upload-avatar" (change)="onImageUpload($event)" style="display: none;"
                            accept="image/*" />
                        <label for="upload-avatar" class="sub-dropdown-lgn" style="cursor: pointer;">
                            <i class="fa fa-upload"></i> Update Image
                        </label>
                    </li>
                    <li>
                        <a class="sub-dropdown-lgn" (click)="logout()">
                            <i class="fa fa-power-off"></i> Logout
                        </a>
                    </li>
                </ul>
            </li>
        </ul>
    </div>
</nav>